<app-badge badgeType="danger" *ngIf="status == 'failure'">
  {{ statusInfo }}
</app-badge>
<app-badge badgeType="success" *ngIf="status == 'success'">
  {{ statusInfo }}
</app-badge>
<app-badge badgeType="secondary" *ngIf="status != '' && status && status != 'success' && status != 'failure'">
  {{ statusInfo }}
</app-badge>